<template>
  <div class="antv-chart-mini">
    <div class="chart-wrapper" :style="{ height: 46 }">
      <v-chart :force-fit="true" :height="height" :data="data" :padding="[36, 5, 18, 5]" :scale="scale">
        <v-tooltip />
        <v-bar position="year*注册人数" />
      </v-chart>
    </div>
  </div>
</template>

<script>
const data = [
  { year: '一月', 注册人数: 68 },
  { year: '二月', 注册人数: 92 },
  { year: '三月', 注册人数: 81 },
  { year: '四月', 注册人数: 145 },
  { year: '五月', 注册人数: 88 },
  { year: '六月', 注册人数: 98 },
  { year: '七月', 注册人数: 68 },
  { year: '八月', 注册人数: 118 },
  { year: '九月', 注册人数: 108 },
  { year: '十月', 注册人数: 68 },
  { year: '十一月', 注册人数: 58 },
  { year: '十二月', 注册人数: 48 }
]

const scale = [{
  dataKey: '注册人数',
  tickInterval: 20
}]

export default {
  name: 'MiniBar',
  data () {
    return {
      data,
      scale,
      height: 100
    }
  }
}
</script>

<style lang="less" scoped>
  @import "chart";
</style>
